import { PositioningStrategy } from '@popperjs/core/lib/popper-lite';
import React, { forwardRef, Ref } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';
import { TimeFormat } from '../../utils/apollo/graphqlSchema';
import { globalFormat } from '../../utils/formatting';

interface IProps {
  placeholderText?: string;
  selectedValue: Date;
  dateFormat?: string;
  onChange: (date: Date | null) => void;
  autoFocus?: boolean;
  className?: string;
  positionStrategy?: PositioningStrategy;
}

const Wrapper = styled.div`
  .react-datepicker {
    width: 160px;
  }

  .react-datepicker__header.react-datepicker__header--time--only {
    display: none;
  }
`;

export default forwardRef(
  (
    {
      placeholderText = 'Select time',
      selectedValue,
      onChange,
      autoFocus,
      className,
      positionStrategy,
    }: IProps,
    ref: Ref<ReactDatePicker>,
  ) => {
    const { timeFormat } = globalFormat.getGlobalFormat();
    const format =
      timeFormat === TimeFormat.TwentyFourHour ? 'HH:mm' : 'h:mm aa';
    return (
      <Wrapper>
        <ReactDatePicker
          ref={ref}
          placeholderText={placeholderText}
          selected={selectedValue}
          strictParsing
          dateFormat={format}
          onChange={onChange}
          disabledKeyboardNavigation
          autoFocus={autoFocus}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption={'Time'}
          timeFormat={format}
          formatWeekDay={(weekdayStr) => weekdayStr.charAt(0)}
          className={className}
          popperPlacement={'bottom-start'}
          showPopperArrow={false}
          popperProps={{
            strategy: positionStrategy || 'fixed',
          }}
          popperModifiers={[
            {
              name: 'preventOverflow',
              enabled: false,
            },
          ]}
        />
      </Wrapper>
    );
  },
);
